import { Checkbox } from '@apia/components';
import { getLabel } from '@apia/util';
import { TFieldValue } from '../util/forms/fillInformation/resolveResponseResult';

export type TTrConfirmProps = {
  formName: string;
  fieldTitle: string;
  fieldName: string;
  currentValueLabel: string;
  currentValue: string | number | boolean;
  newValue: string | number | boolean | TFieldValue;
};

export const OverrideFieldRow = (props: TTrConfirmProps) => {
  const fieldNameTokens = props.fieldName.split('-_-', 2);
  let fieldTitle = '';
  if (fieldNameTokens.length !== 2)
    fieldTitle =
      props.fieldTitle !== undefined && props.fieldTitle !== ''
        ? props.fieldTitle
        : fieldNameTokens[1];
  else
    fieldTitle = getLabel('lblAiActualGridFieldTitle', {
      text: {
        TOK1:
          props.fieldTitle !== undefined && props.fieldTitle !== ''
            ? props.fieldTitle
            : fieldNameTokens[1],
        TOK2: fieldNameTokens[0],
      },
    }).text;
  return (
    <tr
      key={props.fieldName}
      data-formname={props.formName}
      data-newvalue={props.newValue}
      data-currentvalue={props.currentValue ? props.currentValue : ''}
      data-fieldname={props.fieldName}
      id="name"
    >
      <td className="attTitle">{fieldTitle}</td>
      <td data-value={props.currentValue} id="old">
        {String(props.currentValueLabel)}
      </td>
      <td data-value={props.newValue} id="new">
        {String(props.newValue)}
      </td>
      <td key="action">
        <Checkbox defaultChecked />
      </td>
    </tr>
  );
};
